import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from '@/app/App';
import '@/styles/globals.css';
import '@/i18n';

// Register service worker for PWA
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('Nuova versione disponibile. Aggiornare?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App pronta per uso offline');
  },
});

// Error boundary for unhandled errors
window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global error:', { message, source, lineno, colno, error });
  // TODO: Send to error tracking service
};

// Render app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
